(function() {
  'use strict';

  if (typeof window.EcSliderCollection !== 'undefined') {
    return;
  }

  class EcSliderCollection {
    constructor(sectionId) {
      this.sectionId = sectionId;
      this.section = document.querySelector(`.${sectionId}`);
      if (!this.section) return;

      this.tabs = this.section.querySelectorAll('.ec-slider-collection-tab');
      this.panels = this.section.querySelectorAll('.ec-slider-collection-panel');
      this.sliderComponents = this.section.querySelectorAll('slider-component');

      this.init();
    }

    init() {
      if (this.tabs.length > 0 && this.panels.length > 0) {
        this.initTabs();
      }
      
      this.sliderComponents.forEach(component => {
        this.initSlider(component);
      });
    }

    initTabs() {
      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => this.handleTabClick(tab));
      });
    }

    handleTabClick(activeTab) {
      const targetIndex = activeTab.dataset.collectionIndex;
      const tabBgColor = activeTab.dataset.tabBgColor;
      const tabTextColor = activeTab.dataset.tabTextColor;
      const tabActiveBgColor = activeTab.dataset.tabActiveBgColor;
      const tabActiveTextColor = activeTab.dataset.tabActiveTextColor;

      this.tabs.forEach(tab => {
        tab.classList.remove('ec-slider-collection-tab--active');
        tab.style.backgroundColor = tabBgColor;
        tab.style.color = tabTextColor;
      });

      this.panels.forEach(panel => {
        panel.classList.remove('ec-slider-collection-panel--active');
      });

      activeTab.classList.add('ec-slider-collection-tab--active');
      activeTab.style.backgroundColor = tabActiveBgColor;
      activeTab.style.color = tabActiveTextColor;

      const targetPanel = this.section.querySelector(
        `.ec-slider-collection-panel[data-collection-index="${targetIndex}"]`
      );
      
      if (targetPanel) {
        targetPanel.classList.add('ec-slider-collection-panel--active');
      }
    }

    initSlider(sliderComponent) {
      if (!sliderComponent) return;
      
      const slider = sliderComponent.querySelector('.slider');
      if (!slider) return;

      const dotsContainer = sliderComponent.querySelector('[data-slider-controls="bottom-right"]');
      const autoplayEnabled = sliderComponent.dataset.autoplayEnabled === 'true';
      const autoplayInterval = parseInt(sliderComponent.dataset.autoplayInterval) || 4000;

      if (dotsContainer) {
        setTimeout(() => {
          this.setupDotsNavigation(slider, dotsContainer);
          this.updateDotsActiveState(slider, dotsContainer);
          slider.addEventListener('scroll', () => this.updateDotsActiveState(slider, dotsContainer));
        }, 300);
      }

      if (autoplayEnabled) {
        setTimeout(() => this.setupAutoplay(slider, autoplayInterval), 500);
      }
    }

    setupDotsNavigation(slider, dotsContainer) {
      const dots = dotsContainer.querySelectorAll('.slider-counter__link');
      const slides = slider.querySelectorAll('.slider__slide');

      if (dots.length === 0 || slides.length === 0) return;

      dots.forEach(dot => {
        const slideIndex = parseInt(dot.dataset.slideIndex || '0');
        
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          if (slides[slideIndex]) {
            const slideWidth = slides[0].offsetWidth;
            if (slideWidth === 0) return;
            
            const targetPosition = slideWidth * slideIndex;
            
            slider.scrollTo({
              left: targetPosition,
              behavior: 'smooth'
            });
          }
        }, true);
      });
    }

    updateDotsActiveState(slider, dotsContainer) {
      const dots = dotsContainer.querySelectorAll('.slider-counter__link');
      const slides = slider.querySelectorAll('.slider__slide');

      if (dots.length === 0 || slides.length === 0) return;

      const scrollLeft = slider.scrollLeft;
      const slideWidth = slides[0].offsetWidth;
      const currentIndex = slideWidth > 0 ? Math.round(scrollLeft / slideWidth) : 0;

      dots.forEach((dot, index) => {
        if (index === currentIndex) {
          dot.classList.add('slider-counter__link--active');
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.classList.remove('slider-counter__link--active');
          dot.removeAttribute('aria-current');
        }
      });
    }

    setupAutoplay(slider, interval) {
      let autoplayTimer;
      let isUserInteracting = false;

      const goToFirstSlide = () => {
        slider.scrollTo({
          left: 0,
          behavior: 'smooth'
        });
      };

      const goToNextSlide = () => {
        
        const slides = slider.querySelectorAll('.slider__slide');
        if (slides.length <= 1) return;

        const slideWidth = slides[0].offsetWidth;
        const scrollLeft = slider.scrollLeft;
        const currentIndex = slideWidth > 0 ? Math.round(scrollLeft / slideWidth) : 0;
        const nextIndex = (currentIndex + 1) % slides.length;
        const targetPosition = slideWidth * nextIndex;

        if (scrollLeft >= slider.scrollWidth - slider.clientWidth - 1) {
          goToFirstSlide();
          return;
        }

        slider.scrollTo({
          left: targetPosition,
          behavior: 'smooth'
        });
      };

      const startAutoplay = () => {
        if (autoplayTimer) clearInterval(autoplayTimer);
        autoplayTimer = setInterval(() => {
          if (!isUserInteracting) {
            goToNextSlide();
          }
        }, interval);
      };

      const stopAutoplay = () => {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      };

      slider.addEventListener('mouseenter', () => {
        isUserInteracting = true;
        stopAutoplay();
      });

      slider.addEventListener('mouseleave', () => {
        isUserInteracting = false;
        startAutoplay();
      });

      slider.addEventListener('touchstart', () => {
        isUserInteracting = true;
        stopAutoplay();
      });

      slider.addEventListener('touchend', () => {
        setTimeout(() => {
          isUserInteracting = false;
          startAutoplay();
        }, 5000);
      });

      setTimeout(startAutoplay, 1000);
    }
  }

  window.EcSliderCollection = EcSliderCollection;

  function initSliderCollections() {
    if (typeof customElements !== 'undefined' && customElements.get('slider-component')) {
      const sections = document.querySelectorAll('[data-ec-slider-collection]');
      
      sections.forEach(section => {
        const sectionId = section.dataset.ecSliderCollection;
        if (!section.hasAttribute('data-ec-initialized')) {
          section.setAttribute('data-ec-initialized', 'true');
          new EcSliderCollection(sectionId);
        }
      });
    } else {
      setTimeout(initSliderCollections, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(initSliderCollections, 300);
    });
  } else {
    setTimeout(initSliderCollections, 300);
  }
})();
